module.exports = __webpack_public_path__ + "./favicons/android-icon-144x144.png";